var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isModalVisible)?_c('div',{staticClass:"wx"},[_vm._m(0),_c('div',{staticClass:"help-btn"},[_c('span',{on:{"click":function($event){return _vm.wxScanHelp()}}},[_vm._v("微信绑定账号操作说明")])])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-wx"},[_c('div',{staticClass:"qrcode",staticStyle:{"height":"285px","text-align":"center"},attrs:{"id":"qrcode-container"}})])
}]

export { render, staticRenderFns }